export const getShowNearbySuggestion = ({
  destinationPickerInputDisplayValue,
  suggestionsSearchValue
}: {
  destinationPickerInputDisplayValue: string
  suggestionsSearchValue: string
}): boolean => {
  // The user has started typing in the destination picker

  return (
    destinationPickerInputDisplayValue === suggestionsSearchValue ||
    suggestionsSearchValue === ''
  )
}
